import { FeatureTeaser } from '../FeatureTeaser';
import fleetMonitorImage from '../../../assets/images/fleet-monitor.webp';

import { CustomFormattedMessage } from '../../../i18n/i18n';
import { appConfiguration } from '../../../configuration/appConfiguration';

export const LiveMonitorTeaser = () => {
  return (
    <FeatureTeaser
      image={fleetMonitorImage}
      headline={
        <CustomFormattedMessage
          id={'landing.partnerTeaser.fleetMonitor.headline'}
        />
      }
      content={
        <CustomFormattedMessage
          id={'landing.partnerTeaser.fleetMonitor.body'}
        />
      }
      onClick={() => {
        window.open(
          appConfiguration.fleetMonitorWidgetLink,
          '_blank',
          'noopener',
        );
      }}
    />
  );
};
